<div class="compliance-comment-container">
  <div class="title-container">
    <div class="title">Comments</div>
  </div>
  @for (commentItem of commentsList; track commentItem) {
    <div class="comment-item">
      <mds-avatar
        [theme]="commentItem.user_id === userInfo.rid ? 'dark' : 'light'"
        [firstName]="commentItem.user_id === userInfo.rid ? userInfo.firstname : commentItem.firstname"
        [lastName]="commentItem.user_id === userInfo.rid ? userInfo.lastname : commentItem.lastname"
        [imageSrc]="commentItem.user_id === userInfo.rid ? userInfo.avatar : commentItem.avatar"
      ></mds-avatar>
      <div class="comment-container">
        <div class="comment">
          <div class="comment-author">
            {{ commentItem.firstname }} {{ commentItem.lastname }}
            @if (commentItem.user_role) {
              <span>&nbsp;{{ commentItem.user_role }}</span>
            }
          </div>

          <div class="comment-description">
            <div class="comment-description-wrapper">
              <div class="comment-text">{{ addLinebreak(commentItem.content) }}</div>
              <div class="comment-date">
                {{ commentItem.created_at | utcDate: 'dd MMM' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="comment-box-container">
    <div class="comment-box">
      <form class="comment-form" [formGroup]="commentForm">
        <textarea
          #autoResizeTextarea
          formControlName="comment"
          class="comment-input"
          id="autoResize"
          rows="1"
          oninput="
            this.style.height = 'auto';
            this.style.height = this.scrollHeight + 'px';
          "
          (keydown.enter)="showSendOption && onEnter($event, autoResizeTextarea)"
        ></textarea>
        @if (showSendOption) {
          <button type="submit" aria-label="Send Comment" (click)="submitComment(autoResizeTextarea)">
            <mds-icon [pathColors]="commentForm.value.comment ? ['#003c4f'] : []" [key]="icons.SEND"></mds-icon>
          </button>
        }
      </form>
    </div>
  </div>
</div>
